import { makeStyles } from "@saleor/macaw-ui";
import Palette from "@saleor/themes/palette";

const useStyles = makeStyles(
  theme => ({
    root: {
      marginTop: "4rem"
    },
    flip: {
      transform: "rotate(180deg) scaleX(-1)"
    },
    errorText: {
      color: theme.palette.error.light,
      width: "100%",
      marginTop: 3,
      fontSize: 12,
      textAlign: "start"
    },
    bomRow: {
      background: "#fff !important",
      "& td": {
        borderTop: "1px dashed #ccc !important"
      }
    },
    undCancelBtn: {
      "& path": {
        fill: "none !important"
      }
    },
    iconBtn: {
      cursor: "pointer",
      paddingLeft: 0,
      paddingRight: 0,
      minWidth: 30,
      minHeight: 30,
      borderRadius: 4,
      "&:hover": {
        background: "#F2FAFB"
      },
      "&:active": {
        outline: `3px solid rgba(1, 178, 237, 0.32)`
      },
      "&.Mui-disabled": {
        background: `${Palette.grey[300]} !important`,
        color: "#FFF !important",
        "& svg>path": {
          stroke: "#FFF !important"
        }
      }
    },
    splitRow: {
      background: "#F2FAFB !important",
      "& td": {
        borderTop: "1px dashed #ccc !important"
      }
    },
    numberInput: {
      maxWidth: "90px",
      padding: "5px 10px"
    },
    boxQuantity: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-end",
      position: "relative"
    },
    txtInputSelect: {
      "&>div": {
        fontWeight: 400
      }
    },
    singleselect: {
      padding: 12,
      minWidth: 30
    },
    batchRadio: {
      "& .MuiFormControlLabel-root": {
        marginRight: 10
      },
      "& .MuiRadio-root": {
        padding: "2px 3px 2px 14px",
        height: 32
      }
    },
    batchText: {
      height: 32,
      padding: 0,
      width: 96
    },
    inputUnlimit: {
      width: 60,
      "& input": {
        padding: "6px 8px"
      }
    },
    inputtextField: {
      width: "60px"
    },
    commonText: {
      "& .MuiOutlinedInput-input": {
        padding: "6px 16px"
      }
    },
    poDetails: {
      "& input": {
        textOverflow: "ellipsis"
      }
    },
    additionaltxtarea: {
      "& div": {
        paddingTop: 3
      }
    },
    svgIconButton: {
      "&.MuiIconButton-root": {
        width: 36,
        border: "none",
        background: "transparent",
        color: theme.palette.info.main,
        "&:hover": {
          color: theme.palette.info.dark
        }
      }
    },
    cippphead: {
      color: theme.palette.info.main
    },
    freezCell: {
      position: "sticky",
      background: "inherit",
      zIndex: 3,
      "&.MuiTableCell-body": {
        zIndex: 2
      },
      "& .MuiTypography-root": {
        letterSpacing: "-0.3px !important"
      }
    },
    required: {
      color: theme.palette.error.main,
      "& :after": {
        content: "*"
      }
    },
    btnExternal: {
      height: 32,
      margin: "-3px -0.8px",
      minWidth: 32,
      width: 36,
      padding: 6
    },
    btnBom: {
      height: 32,
      margin: "-3px -0.8px",
      minWidth: 32,
      width: 36,
      padding: 2
    },
    btnSearch: {
      width: "100%",
      height: "20px",
      right: "auto",
      top: "8px",
      marginLeft: "0px",
      padding: " 6px",
      minWidth: "32px",
      position: "absolute",
      background: "transparent",
      justifyContent: "right",
      "&:hover": {
        background: "transparent"
      },
      "&:focus": {
        background: "transparent"
      }
    },

    rowFlex: {
      display: "flex",
      alignItems: "center",
      gap: 10
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5,
      fontSize: 12
    },
    toleranceStyle: {
      display: "flex",
      flexWrap: "nowrap",
      width: "100%",
      height: "24px",
      justifyContent: "space-around"
    },
    searchPlantWrapper: {
      padding: "8px 16px 16px",
      minWidth: "384px",
      boxShadow: "0px 8px 24px 0px rgba(0, 0, 0, 0.24)",
      borderRadius: "12px"
    },
    buttonCancel: {
      height: "32px",
      border: "1px solid #222222",
      fontSize: "16px",
      borderRadius: "4px",
      color: "#222222",
      width: "100%",
      maxWidth: "168px"
    },
    buttonConfirm: {
      height: "32px",
      background: "#222222",
      fontSize: "16px",
      borderRadius: "4px",
      color: "#ffffff",
      width: "100%",
      maxWidth: "168px"
    },
    btnWrapper: {
      display: "flex",
      justifyContent: "space-between"
    },
    btnApplyOpen: {
      color: "#009FB8",
      background: "#F2FAFB",
      outline: "1px solid #009FB8",
      boxShadow:
        "rgba(0, 0, 0, 0.16) 0px 2px 3px, rgba(0, 0, 0, 0.23) 0px 2px 3px"
    },
    boxCancel: {
      "& .MuiTypography-root": {
        color: `${theme.palette.error.dark} !important`
      },
      background: `${theme.palette.grey[200]} !important`,
      borderRadius: 4,
      width: 72,
      padding: "3px 8px",
      userSelect: "none"
    },
    buttonApply: {
      borderRadius: "4px",
      padding: "0.4rem 0.4rem",
      fontWeight: 400,
      fontSize: "1.2rem",
      lineHeight: "18px",
      background: "#009FB8",
      color: "white",
      marginLeft: "12px",
      boxShadow:
        "rgba(0, 0, 0, 0.16) 0px 2px 3px, rgba(0, 0, 0, 0.23) 0px 2px 3px",
      "&:hover, &:active": {
        color: "#009FB8",
        background: "#F2FAFB",
        outline: "1px solid #009FB8",
        boxShadow:
          "rgba(0, 0, 0, 0.16) 0px 2px 3px, rgba(0, 0, 0, 0.23) 0px 2px 3px"
      }
    },
    svgDatePicker: {
      marginRight: "0.8rem"
    },
    boxPlant: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      "& >span": {
        marginBottom: "0.8rem"
      }
    },
    fullWidth: {
      width: "100%"
    },
    advancedTableRoot: {
      marginTop: "0px !important"
    },
    tabBox: { display: "flex" },
    tableTabActive: {
      WebkitClipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      width: "200px",
      height: "40px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "6px",
      background: theme.palette.info.dark,
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      position: "relative",
      borderBottom: 0
    },
    innerTabActive: {
      WebkitClipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      width: "199px",
      height: "39px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "5px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      top: 1,
      left: 1,
      background: theme.palette.info.main,
      position: "absolute",
      borderBottom: 0,
      color: "#FFFFFF"
    },
    tableTab: {
      WebkitClipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      width: "200px",
      height: "40px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "6px",
      background: theme.palette.grey[400],
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      position: "relative",
      borderBottom: 0
    },
    innerTab: {
      WebkitClipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      width: "199px",
      height: "39px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "5px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      top: 1,
      left: 1,
      background: theme.palette.grey[300],
      color: theme.palette.grey[600],
      position: "absolute",
      borderBottom: 0
    },
    tabB: {
      marginLeft: "-2rem"
    },
    z0: {
      zIndex: 0
    },
    z1: {
      zIndex: 1
    },
    z2: {
      zIndex: 2
    },
    zMax: {
      zIndex: 100
    },
    hidden: {
      display: "none"
    }
  }),
  {
    name: "ItemDetailCS"
  }
);

export default useStyles;
